<template>
  <div ref="wrap">
    <div slot="reference" class="wrap-input">
      <el-input
        v-model="input"
        class="cur-input sel-input"
        :placeholder="placeholder"
        @blur="blur"
        @input="inputValue"
        :disabled="disabled"
        :maxlength="maxlength">
      </el-input>
      <div class="icon">
        <el-popover
          placement="top"
          width="160"
          trigger="hover"
          v-model="tipVisible">
          <p style="padding: 10px;">{{tipContent}}</p>
          <i class="iconfont icon-warning" slot="reference" v-show="customTrem"></i>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'autocomplete',
  data() {
    return {
      input: '',
      tipVisible: false,
    };
  },
  props: {
     // input 输入值
    value: {
      type: Number,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 4,
    },
    customTrem: {
      type: Boolean,
      default: false,
    },
    tipContent: {
      type: String,
      default: '该药品库存不足',
    },
    placeholder: {
      type: String,
      default: '数量',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    blur() {
      this.$emit('blur', this.input);
    },
    inputValue() {
      this.$emit('input', this.input);
    },
  },
  mounted() {
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.input = val;
      },
    },
  },
};
</script>
